<template>
  <section id="animated-counter" class="member_counter my-5">
    <b-container>
      <b-row>
        <b-col lg="3" sm="6">
          <div class="single_member_counter">

            <slot name="p-1"/>

          </div>
        </b-col>
        <b-col lg="3" sm="6">
          <div class="single_member_counter">

            <slot name="p-2"/>

          </div>
        </b-col>
        <b-col lg="3" sm="6">
          <div class="single_member_counter">

            <slot name="p-3"/>

          </div>
        </b-col>
        <b-col lg="3" sm="6">
          <div class="single_member_counter">

            <slot name="p-4"/>

          </div>
        </b-col>

      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: 'S23',
  methods: {
    counterAnimation(el, count) {
      var divisor = count;
      var speed = Math.round(count / divisor);
      var start = 0;
      var interval = setInterval(function () {
        if (start >= count) {
          clearInterval(interval);
        } else {
          start++;
          el.textContent = start;
        }
      }, speed);
    },
    onVisible(element, callback) {
      new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.intersectionRatio > 0) {
            callback(element);
            observer.disconnect();
          }
        });
      }).observe(element);
    }
  },
  mounted() {
    const counterAbleElements = document.querySelectorAll('.counter');


    this.onVisible(document.querySelector("#animated-counter"), () => {
      counterAbleElements.forEach(el => {
        const count = el.getAttribute('data-count');
        this.counterAnimation(el, count);
      });
    });

  }
}
</script>

<style scoped>
.member_counter .single_member_counter {
  margin: 20px 0px;
}

.member_counter .single_member_counter {
  text-align: center;
}

.member_counter .single_member_counter span {
  font-size: 60px;
  font-weight: 700;
  color: #fff;
}

@media only screen and (min-width: 992px) and (max-width: 1200px) {
  .member_counter .single_member_counter span {
    line-height: 67px;
    font-size: 40px;
  }
}

.member_counter {
  background-image: linear-gradient(90deg, var(--primary) 0%, var(--secondary) 100%);
}

.member_counter .single_member_counter h4 {
  color: #fff;
  font-size: 24px;
  font-size: 600;
  margin-top: 28px;
  text-transform: capitalize;
  position: relative;
  text-align: center;
}

.member_counter .single_member_counter h4:after {
  position: absolute;
  left: 0;
  top: -20px;
  right: 0;
  margin: 0 auto;
  width: 60px;
  height: 1px;
  background-color: #fff;
  content: "";
}

@media only screen and (min-width: 992px) and (max-width: 1200px) {
  .member_counter .single_member_counter h4:after {
    top: -10px;
  }
}


</style>